enum TenantEnum {
  Dash = 'dash',
  Hagerty = 'hagerty',
  Ignite = 'ignite',
  KeeyPartners = 'keeypartners',
  Quotax = 'quotax',
  Switch = 'switch',
  Tractive = 'tractive',
  Yoga = 'yoga',
  Zoomcover = 'zoomcover',
  Zen = 'zen',
  Demo02 = 'demo02',
}

export default TenantEnum
